import { each, keys, map, reduce } from 'lodash';

import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Revision } from '../revision/revision';
import { DialogService, NotifierService } from '../ui';
import { ExecutionDossier } from './execution';
import { Document, DocumentField } from '../document/document';
import { DocumentService } from '../document/document.service';
import { Operation } from '../operation/operation';
import { finalize } from 'rxjs/operators';
import { DossierSearchDialogComponent } from '../dossier/dossier-search-dialog.component';
import { Dossier } from '../dossier/dossier';

@Component({
  selector: 't-select-root-fields',
  templateUrl: './select-root-fields.component.html',
})
export class SelectRootFieldsComponent implements OnInit {

  @Input()
  operation: Operation

  @Input()
  revision: Revision

  @Output()
  selected = new EventEmitter<ExecutionDossier[]>();

  dossiers: ExecutionDossier[]

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private documentService: DocumentService,
    private notifier: NotifierService,
    private dialogService: DialogService
  ) { }

  ngOnInit() {
    this.fetch();
  }

  private fetch() {
    if (this.revision) {
      this.notifier.startProgress();

      this.documentService
        .documents(this.operation.id, this.revision.id).pipe(
        finalize(() => this.notifier.endProgress()))
        .subscribe((result) => {
          this.extractRootFields(result.revision.documents);
        });
    }
  }

  private extractRootFields(documents: Document[]) {

    const rootFields = {};

    each(documents, (document: Document) => {
      each(document.fields, (field: DocumentField) => {
        
        if (field.text.startsWith('$')) {
          const name = field.text.split('.')[0].toLowerCase();

          rootFields[name] = true;
        }
      })
    });


    this.dossiers = map(keys(rootFields).sort(), f => {
      return new ExecutionDossier({
        id: null,
        root_field: f,
      });
    });


    if(this.dossiers.length === 0) {
      this.selected.emit([]);
    }
  }

  get requiredDossiers() {
    return reduce(this.dossiers, (acc, dossier) => {
      return acc + (dossier.dossier ? 0 : 1);
    }, 0);
  }

  onSelect(rootDossier: ExecutionDossier) {
    
    this.dialogService.show({
      component: DossierSearchDialogComponent,
      props: {

        onClose: () => {
          this.dialogService.hide();
        },

        onSelect: (dossier: Dossier) => {
          this.dialogService.hide();

          rootDossier.dossier = dossier;
          rootDossier.id = dossier.id;

          if (this.requiredDossiers === 0) {
            this.selected.emit(this.dossiers);
          }
        }
      }
    });
  }
}
